export default "__VITE_ASSET__B32s5cXd__"